interface IProps {
    disabled?: boolean;
    cursor?: "pointer" | "zoomIn" | "zoomOut" | "notAllowed" | "auto";
}

export type Props = IProps & Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'style'>;

export const MprcClickable: React.FC<Props> = (props) => {
    const { children, disabled, cursor, onClick, ...rest } = props;

    return (
        <div
            {...rest}
            onClick={disabled ? undefined : onClick}
            style={
                {
                    display: "inline",
                    cursor: disabled ? "not-allowed" : cursor ?? "pointer"
                }
            }
        >
            {children}
        </div>
    );
};
